import { render, staticRenderFns } from "./adjust-preimum.vue?vue&type=template&id=24e9ab12&scoped=true&"
import script from "./adjust-preimum.vue?vue&type=script&lang=js&"
export * from "./adjust-preimum.vue?vue&type=script&lang=js&"
import style0 from "./adjust-preimum.vue?vue&type=style&index=0&id=24e9ab12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e9ab12",
  null
  
)

export default component.exports